import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function MetaPixel() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
      console.log("Meta Pixel PageView triggered:", location.pathname);
    }
  }, [location.pathname]);

  return null;
}

export default MetaPixel;